import emptyReducer from './emptyReducer';

const toBoolean = emptyReducer<boolean>(false).with({
  YesNo: (question, positive) => positive || false,
});

export default toBoolean;
